import { BASE_URL } from "@constants/api.constants";
import { uploadImageFile } from "@utils/upload.util";

export const getBannerInputs = (initialValues) => [
  {
    groupName: "Banner",    
    type: "TEXT",
    label: "Banner Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the Banner Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Banner Name is required !",
      },
    ],
  },
  {
    groupName: "Banner",
    type: "TEXT",
    label: "Sort Order",
    id: "sort_order",
    name: "sort_order",
    value: initialValues?.sort_order || "",
    placeholder: "Enter the Sort Order",
  },
  {
    groupName: "Banner",
    type: "FILE_UPLOAD",
    label: "Banner Image",
    id: "image",
    name: "image",
    value: initialValues?.image || "",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [],
  },
  {
    groupName: "Banner",
    type: "TEXT",
    label: "Link",
    id: "url",
    name: "url",
    value: initialValues?.url || "",
    placeholder: "Enter the Link",
  },
  {
    groupName: "Banner",
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: [
      { name: "Enable", value: "1" },
      { name: "Disable", value: "2" },
    ],
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },

  {
    groupName: "",
    // groupClass: "col-md-12",
    type: "FORM_REPEATER",
    validations: [],
    name: "repeater",
    value: initialValues?.repeater || null,
    inputs: [
      {
        type: "TEXT",
        label: "Banner Name",
        id: "name",
        name: "name",
        placeholder: "Enter the Banner Name",
        size: 2,
      },
      {
        type: "TEXT",
        label: "Sort Order",
        id: "sort_order",
        name: "sort_order",
        placeholder: "Enter the Sort Order",
        size: 2,
      },
      {
        type: "FILE_UPLOAD",
        label: "Banner Image",
        id: "image",
        name: "image",
        value: initialValues?.image || "",
        filePrefix: BASE_URL + "app-source/images/",
        handleSelfUpload: uploadImageFile,
        validations: [],
        size: 4,
      },
      {
        type: "TEXT",
        label: "Link",
        id: "url",
        name: "url",
        value: initialValues?.url || "",
        placeholder: "Enter the Link",
        size: 2,
      },
    ],
  },
];
